// extracted by mini-css-extract-plugin
export default {"map__container":"MapBlock_map__container__6tI4w","map__board":"MapBlock_map__board__xdjrU","map__title":"MapBlock_map__title__4OEOK","map":"MapBlock_map__KWREA"};